<template>
    <div>
        <p class="text-muted mb-4 mt-3 text-center">
            Enter your email address and password to access admin panel.
        </p>

        <b-form @submit.prevent="tryToLogIn">
            <b-form-group label="Email" label-for="email">
                <b-form-input
                    id="email"
                    v-model="email"
                    type="email"
                    required
                    placeholder="Enter email"
                />
            </b-form-group>

            <b-form-group label="Password" label-for="password">
                <b-form-input
                    id="password"
                    v-model="password"
                    type="password"
                    required
                    placeholder="Enter password"
                />
            </b-form-group>

            <b-alert v-model="isAuthError" variant="danger" dismissible>
                Wrong credentials!
            </b-alert>

            <b-form-group class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block">
                    Log In
                </b-button>
            </b-form-group>
        </b-form>

        <div class="row mt-3">
            <div class="col-12 text-center">
                <router-link to="/forgot-password">
                    Forgot your password?
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes } from 'http-status-codes';

export default {
    page: {
        title: 'Login'
    },

    data() {
        return {
            email: '',
            password: '',
            isAuthError: false,
            tryingToLogIn: false
        };
    },

    methods: {
        ...mapActions({
            login: 'auth/login'
        }),

        async tryToLogIn() {
            this.tryingToLogIn = true;
            this.authError = null;

            try {
                await this.login({
                    email: this.email,
                    password: this.password
                });

                this.tryingToLogIn = false;
                this.isAuthError = false;

                const { redirectFrom = '/' } = this.$route.query;

                const redirectRoute = !['/logout', '/login'].includes(
                    redirectFrom
                )
                    ? redirectFrom
                    : { name: 'dashboard' };

                this.$router.push(redirectRoute);
            } catch (error) {
                console.error(error);

                if (error.response.status === StatusCodes.UNAUTHORIZED) {
                    this.isAuthError = true;

                    return;
                }

                this.$toasterError();
            }
        }
    }
};
</script>
